module.exports = __webpack_public_path__ + "static/media/gelbox_eject_gel.1f16eda2.svg";